module.exports = __webpack_public_path__ + "img/title.e5a117ab.png";